module.exports = __webpack_public_path__ + "img/webnew44.501daea4.jpg";